/**
 * app事件默认参数, 4:拉起充值档位, 5:消耗金币, 6:调起用户IM
 */
export const AppActionDefaultParams = {
  2: {
    uid: 0,
    activityId: ''
  },
  3: {
    uid: 0
  },
  4: {
    uid: 0,
    productId: '',
    activityId: ''
  },
  5: {
    uid: 0,
    activityId: '',
    currencyType: '',
    amount: ''
  },
  6: {
    uid: 0
  },
  13: {
    uid: '', // uid
    contentId: '' // 动态id
  }
}
